import { Account, GenderType, PlatformOSType } from '@/model';
import {
  GetAccountCepResponse,
  GetAccountByIdResponse,
  GetAccountAvatarResponse,
  PutAccountAvatarResponse,
  GetAccountTermsResponse,
  GetAccountItemResponse,
  GetAccountResponse,
  PutAccountContactResponse,
  GetAccountNotificationAccountResponse,
} from '@/services/response/account';

export class AccountConverter {
  static toDomainFromGetAccountItemResponse(response: GetAccountItemResponse): Account {
    return {
      uuid: response.uuid,
      status: response.status,
      document: '',
      business_unit_uuid: '',
      email: response.email,
      mobile_number: response.mobile_number,
      first_name: response.first_name,
      last_name: response.last_name,
      birthdate: response.birthdate,
      address: {
        line1: '',
        line2: '',
        line3: '',
        neighborhood: '',
        city: '',
        state: '',
        country: '',
        postal_code: '',
      },
      card_number: response.card_number,
      gender: GenderType.NO_ANSWER,
      nickname: '',
      language: '',
      last_app_version: response.last_app_version || "",
      last_app_platform: PlatformOSType.WEB,
      blocked_at: '',
      enabled_at: response.enabled_at,
      created_at: response.created_at,
      updated_at: response.updated_at,
      last_access_at: response.last_access_at,
      avatar_url: '',
    };
  }

  static toDomainFromPaginatedResponse(response: GetAccountResponse): Account[] {
    return response.data.map(AccountConverter.toDomainFromGetAccountItemResponse);
  }

  static toDomainFromGetAccountByIdResponse(response: GetAccountByIdResponse): Account {
    return {
      uuid: response.uuid,
      status: response.status,
      document: response.document,
      business_unit_uuid: '',
      email: response.email,
      mobile_number: response.mobile_number,
      first_name: response.first_name,
      last_name: response.last_name,
      birthdate: response.birthdate,
      address: {
        line1: response?.address?.line1,
        line2: response?.address?.line2,
        line3: response?.address?.line3,
        neighborhood: response?.address?.neighborhood,
        city: response?.address?.city,
        state: response?.address?.state,
        country: response?.address?.country,
        postal_code: response?.address?.postal_code,
      },
      card_number: response.card_number,
      gender: response.gender,
      nickname: response.nickname,
      language: '',
      last_app_version: response.last_app_version || "",
      last_app_platform: PlatformOSType.WEB,
      blocked_at: '',
      enabled_at: '',
      created_at: response.created_at,
      updated_at: response.updated_at,
      last_access_at: response.last_access_at || '',
      avatar_url: response.avatar_url || '',
    };
  }

  static toDomainFromPutAccountContactResponse(response: PutAccountContactResponse): Account {
    return {
      uuid: response.uuid,
      status: response.status,
      document: response.document,
      business_unit_uuid: '',
      email: response.email,
      mobile_number: response.mobile_number,
      first_name: response.first_name,
      last_name: response.last_name,
      birthdate: response.birthdate,
      address: {
        line1: response?.address?.line1,
        line2: response?.address?.line2,
        line3: response?.address?.line3,
        neighborhood: response?.address?.neighborhood,
        city: response?.address?.city,
        state: response?.address?.state,
        country: response?.address?.country,
        postal_code: response?.address?.postal_code,
      },
      card_number: response.card_number,
      gender: response.gender,
      nickname: response.nickname,
      language: '',
      last_app_version: '',
      last_app_platform: PlatformOSType.WEB,
      blocked_at: '',
      enabled_at: '',
      created_at: response.created_at,
      updated_at: response.updated_at,
      last_access_at: '',
      avatar_url: '',
    };
  }

  static toDomainFromGetAccountAvatarResponse(response: GetAccountAvatarResponse): Partial<Account> {
    return { avatar_url: response.avatar };
  }

  static toDomainFromPutAccountAvatarResponse(response: PutAccountAvatarResponse): Partial<Account> {
    return { avatar_url: response.avatar };
  }

  static toDomainFromGetAccountTermsResponse(response: GetAccountTermsResponse): {
    key: string;
    url: string;
    isAccepted: boolean;
  } {
    return {
      key: response.key,
      url: response.url,
      isAccepted: response.is_accepted,
    };
  }

  static toDomainFromGetAccountCepResponse(response: GetAccountCepResponse): {
    postalCode: string;
    neighborhood: string;
    addressLine: string;
    state: string;
    city: string;
  } {
    return {
      postalCode: response.postal_code,
      neighborhood: response.neighborhood,
      addressLine: response.line1,
      state: response.state,
      city: response.city,
    };
  }

  static toDomainFromGetAccountNotificationAccountResponse(response: GetAccountNotificationAccountResponse): any {
    return response.map(item => ({
      uuid: item.uuid,
      title: item.title,
      content: item.content,
      read: item.read,
      created_at: item.created_at,
      target_type: item.target_type,
      custom_target: item.custom_target,
    }));
  }
}
